var _path, _g, _path2, _g2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      transform: "transformX(50px)"
    },
    width: 252,
    height: 233,
    viewBox: "0 0 252 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9102 104.734V93.8238C10.9102 48.6337 47.1369 12 91.8248 12C136.513 12 172.739 48.6337 172.739 93.8238V104.734",
    stroke: "white",
    strokeWidth: 21.8197
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.197 108.37V96.5381C218.197 61.8997 190.518 33.8197 156.375 33.8197C122.231 33.8197 94.5522 61.8997 94.5522 96.5381V108.37",
    stroke: "#0E001C",
    strokeOpacity: 0.48,
    strokeWidth: 45.4576
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.924 104.734V92.9015C210.924 58.2631 183.245 30.1831 149.101 30.1831C114.958 30.1831 87.2791 58.2631 87.2791 92.9015V104.734",
    stroke: "white",
    strokeWidth: 21.8197
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.458 110.189V97.4604C45.458 74.3633 66.6242 55.6394 92.734 55.6394C118.844 55.6394 140.01 74.3633 140.01 97.4604V110.189",
    stroke: "#0E001C",
    strokeOpacity: 0.48,
    strokeWidth: 38.1844
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0947 104.734V92.0055C49.0947 68.9084 68.2257 50.1844 91.8249 50.1844C115.424 50.1844 134.555 68.9084 134.555 92.0055V104.734",
    stroke: "white",
    strokeWidth: 21.8197
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.732 160.29C197.237 157.692 200.013 152.887 200.013 147.687L200.011 104.734L221.831 104.733L221.833 158.192C221.834 164.693 218.364 170.699 212.732 173.946L166.369 200.674L120 227.413C114.378 230.654 107.456 230.655 101.834 227.413L9.10121 173.946C3.46991 170.699 0.000203703 164.693 0.000534291 158.193L0.00325312 104.733L21.8229 104.734L21.8207 147.687C21.8205 152.888 24.5962 157.692 29.1013 160.29L103.651 203.273C108.148 205.866 113.686 205.866 118.183 203.273L155.469 181.772L192.732 160.29Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.519 138.063C159.041 135.47 161.829 130.656 161.829 125.444L161.828 104.734L183.647 104.733L183.649 135.976C183.649 142.492 180.163 148.509 174.511 151.751L147.255 167.381L119.964 183.035C114.361 186.249 107.473 186.249 101.87 183.035L74.5793 167.381L47.3224 151.751C41.6704 148.509 38.1845 142.492 38.1849 135.976L38.1865 104.733L60.0061 104.734L60.0051 125.444C60.0048 130.656 62.7932 135.47 67.3145 138.063L103.68 158.92C108.162 161.49 113.672 161.49 118.154 158.92L154.519 138.063Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.675 114.919C121.362 112.855 123.645 108.959 123.644 104.734V104.734L145.464 104.733L145.465 113.707C145.465 120.289 141.908 126.357 136.166 129.573L119.801 138.737C114.282 141.828 107.552 141.828 102.033 138.737L85.6682 129.573C79.9256 126.357 76.3691 120.289 76.3695 113.707L76.3699 104.733L98.1896 104.734V104.734C98.1894 108.959 100.472 112.855 104.159 114.919L104.698 115.221C108.562 117.385 113.272 117.385 117.136 115.221L117.675 114.919Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 60.9137,
    y: 0.180986,
    width: 190.922,
    height: 119.099,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.45492,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 15.4559,
    y: 25.6374,
    width: 154.556,
    height: 95.461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.45492,
    result: "effect1_foregroundBlur"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcLogo);
export default __webpack_public_path__ + "static/media/arc-logo.692554ee62f62dbff4ae6cab064db303.svg";
export { ForwardRef as ReactComponent };